<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Wykluczenia opcji</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/product-option-exclusion/list">
            Wykluczenia opcji
          </router-link>
        </li>
        <li class="active">
          <strong>Nowa</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Dane wykluczenia opcji</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Opcja 1</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="pOptionsExObj.option_1"
                    mode="single"
                    placeholder="Opcja 1"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="options"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.option_1" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.option_1[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opcja 2</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="pOptionsExObj.option_2"
                    mode="single"
                    placeholder="Opcja 2"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="options"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.option_2" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.option_2[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="hr-line-dashed"></div>

              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link
                    class="btn btn-white"
                    to="/product-option-group/list"
                  >
                    Anuluj
                  </router-link>
                  <button
                    v-if="canAddExclusion"
                    @click="create"
                    class="btn btn-primary"
                  >
                    Dodaj
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { hasPermission } from "../../permissions";
import { exclusionPermissionsConst } from "../../constants/productConstants";
import { useStore } from "vuex";
import router from "../../router/router";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

export default {
  name: "ProductOptionExCreate",
  mixins: [],
  components: {
    Multiselect,
  },
  props: {},

  setup() {
    const canAddExclusion = computed(() =>
      hasPermission(exclusionPermissionsConst.add)
    );
    const pOptionsExObj = ref({});
    const errorsAdminData = ref();
    const options = ref([]);
    const showErrors = ref(false);
    const store = useStore();
    const createpOptionsExData = computed(
      () => store.getters.getCreatepOptionsExData
    );
    const adminProductOptionsData = computed(
      () => store.getters.getAdminProductOptionsData
    );

    const create = () => {
      if (!canAddExclusion.value) {
        return;
      }
      showErrors.value = true;
      store.dispatch("createpOptionsEx", pOptionsExObj.value);
    };
    store.dispatch("getAdminProductOptions");

    watch(
      () => createpOptionsExData.value,
      function (newValue) {
        if (newValue.status === 201) {
          router
            .push({
              name: "ProductOptionExList",
              path: "/product-option-exclusion/list",
            })
            .then(() => {
              store.dispatch("showToaster", {
                type: "success",
                content: "Nowe wykluczenie zostało dodane",
              });
            });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => adminProductOptionsData.value,
      function (newValue) {
        newValue.data?.forEach((element) => {
          options.value.push({
            name: "[" + element.pk + "] " + element.label,
            value: element.pk,
          });
        });
      }
    );

    return {
      canAddExclusion,
      pOptionsExObj,
      errorsAdminData,
      showErrors,
      create,
      options,
    };
  },
  computed: {},
};
</script>
